import { Action } from './Action';
import Game from './Game';
import Hint from './Hint';
import gaLog from '@/utils/ga';



//
// Configs type for the different 
//

export type combination_config_t = {
    code: string,
    tolerance?: number,
};

export type keypad_config_t = {
    code: string,
    font?: string,
    layout?: string[][],
}

export type wirecut_config_t = {
    code: string,
    layout: {
        connectorsA: (null|string)[],
        connectorsB: (null|string)[],
        wires: {ini:string|number, end:string|number, color:string}[],
        seed: number,
    },
    reseteable?: boolean,
    model?: string,
}

export type text_config_t = {
    code: string,
};

export type laptop_config_t = {
    code: string,
};

export type cryptex_config_t = {
    code: string,
    letters?: string[],
};

// Global type
export type config_t =
    combination_config_t |
    keypad_config_t      |
    wirecut_config_t     |
    text_config_t        |
    laptop_config_t      |
    cryptex_config_t     |
    undefined;


//
// Puzzle class
//
export class Puzzle {

    static current_id = 0;

    id: string;
    type: string;
    config: config_t;
    actions: Action[] = [];
    solved: boolean = false;
    hints: Hint[] = [];

    constructor(type: string, config: config_t){
        this.id = `puz-${++Puzzle.current_id}`;
        this.type = type;
        this.config = config;
    }

    add(item: Action|Hint){

        if(item instanceof Hint){
            this.hints.push(item);
            return;
        }

        this.actions.push(item);
    }
    

    async solveEvent(){

        console.log("solveEvent.", this.id);
        const game = await Game.current();

        gaLog('solve', {
            puzzle: this.id,
            time: game?.getElapsedMinutes(),
        });

        game!.addEvent('solved', this.id);
    }


    solve(quiet:boolean){

        if(this.solved){
            throw new Error("Puzzle already solved");
        }

        this.solved = true;
        this.actions.forEach(a => a.run(quiet));
    }

}


